import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import { formatCurrency, formatDate } from "../../v2_actions/purchased_trolley"

export default function InvoiceTemplate({
  trolley,
}) {
  const totalAmount = trolley?.ledger_transaction_bank_credit;
  const isSalestaxRegistered = trolley?.photographer_salestax_registered;

  const subtotal = isSalestaxRegistered ? totalAmount / 1.1 : totalAmount;
  const gstAmount = isSalestaxRegistered ? totalAmount / 1.1 * 0.1 : 0;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.companyName}>Bossfotos</Text>
          <Text style={styles.companyDetails}>
            23 St Thomas St, Bronte, 2024
          </Text>
          <Text style={styles.companyDetails}>
            ACN 648 272 539
          </Text>
          <Text style={styles.companyDetails}>
            info@bossfotos.com | www.bossfotos.com
          </Text>
        </View>
        <View style={styles.billingRow}>
          <View style={styles.billTo}>
            <Text style={styles.label}>Bill To:</Text>
            <Text>{trolley?.customer_first_name || ""}</Text>
          </View>

          <View style={styles.invoiceMeta}>
            <Text>
              <Text style={styles.label}>Invoice No: </Text>
              {trolley?.ledger_transaction_id || ""}
            </Text>
            <Text>
              <Text style={styles.label}>Date: </Text>
              {formatDate(trolley?.created_at)}
            </Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colDescription}>Description</Text>
            <Text style={styles.colPrice}>Price</Text>
            <Text style={styles.colTotal}>Total</Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.colDescription}>
              Digital Photographs
            </Text>
            <Text style={styles.colPrice}>{formatCurrency(totalAmount)}</Text>
            <Text style={styles.colTotal}>{formatCurrency(totalAmount)}</Text>
          </View>
        </View>
        <View style={styles.totalsContainer}>
          <View style={styles.totalRow}>
            <Text>Subtotal (ex GST)</Text>
            <Text>{formatCurrency(subtotal)}</Text>
          </View>
          <View style={styles.totalRow}>
            <Text>GST (10%)</Text>
            <Text>{formatCurrency(gstAmount)}</Text>
          </View>
          <View style={styles.totalRow}>
            <Text style={styles.grandTotal}>Total (inc GST)</Text>
            <Text style={styles.grandTotal}>{formatCurrency(totalAmount)}</Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 11,
    fontFamily: "Helvetica"
  },
  header: {
    marginBottom: 20
  },
  companyName: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 4
  },
  companyDetails: {
    fontSize: 10,
    color: "#555"
  },
  billingRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    marginBottom: 20
  },
  billTo: {
    width: "50%"
  },
  invoiceMeta: {
    width: "40%",
    textAlign: "right"
  },
  label: {
    fontWeight: "bold"
  },
  table: {
    marginTop: 10,
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid"
  },
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
    padding: 6,
    fontWeight: "bold"
  },
  tableRow: {
    flexDirection: "row",
    padding: 6
  },
  colDescription: {
    width: "50%"
  },
  colPrice: {
    width: "25%",
    textAlign: "right"
  },
  colTotal: {
    width: "25%",
    textAlign: "right"
  },
  totalsContainer: {
    marginTop: 20,
    alignItems: "flex-end"
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: 200,
    marginBottom: 4
  },
  grandTotal: {
    marginTop: 8,
    fontSize: 13,
    fontWeight: "bold"
  }
});
